import {
  API_GET_METHOD,
  API_POST_METHOD,
  API_PUT_METHOD
} from 'global_config/constant-global';
import { axiosLabAPI } from 'services/axios';
import { showMessage } from 'services/settings/message';

export async function panelListAPI() {
  let panelList = {
    data: [],
    status: null
  };

  

  try {

    const content = {
      method: API_GET_METHOD,
      url: `settings/panelexamrequest?p_all_flag=1`
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    panelList = {
			data: data.RECORDS,
			status: data.STATUSCODE,
		};

  }
  catch (e) {
    showMessage(e);
  }

  return panelList;
}

export async function getPanelInfoAPI(panelID) {
  let panelInfo = {
    data: [],
    status: null
  };

  try {

    const content = {
      method: API_GET_METHOD,
      url: `settings/panelexamrequest?p_panel_request_id=${panelID}`
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    if (data && data.STATUSCODE === 200 && data.RECORDS) {
      panelInfo = {
        data: data.RECORDS,
        status: data.STATUSCODE
      };
    }

  }
  catch (e) {
    showMessage(e);
  }

  return panelInfo;
}

export async function createdPanelAPI(payload) {
  let createdPanel = {};

  try {

    const content = {
      method: API_POST_METHOD,
      url: `settings/panelexamrequest`,
      data: payload
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;


    createdPanel = {
			data: data.RECORDS,
			status: data.STATUSCODE,
		};
  }
  catch (e) {
    showMessage(e);
  }

  return createdPanel;
}

export async function updatePanelListAPI(payload) {
  let updatedPanel = {};

  try {
    const content = {
      method: API_PUT_METHOD,
      url: `settings/panelexamrequest`,
      data: payload
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    updatedPanel = {
			data: data.RECORDS,
			status: data.STATUSCODE,
		};
  }
  catch (e) {
    showMessage(e);
  }

  return updatedPanel;
}
export async function applyPanelSorting(payload) {
	let responseData = {};

	try {
		const content = {
			method: API_PUT_METHOD,
			url: `settings/panelrequestsort`,
			data: {
				p_panel_request_sorting_array: JSON.stringify(payload)
			}
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		responseData = {
			data: data.RECORDS,
			status: data.STATUSCODE,
		};
	}
	catch (e) {
		showMessage(e);
	}

	return responseData;
}
